import React, { useState } from 'react';
import './CastingApplicationPage.css';

function DesignerApplicationPage({ onNavigate }) {
  const [submitting, setSubmitting] = useState(false);
  const [consentChecked, setConsentChecked] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    profession: '',
    yearsExperience: '',
    specialty: '',
    portfolioLink: '',
    websiteLink: '',
    instagram: '',
    availability: '',
    travelFlexibility: '',
    bio: ''
  });

  const getOrCreateGenesisID = () => {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.genesisID) {
      return currentUser.genesisID;
    }

    let wandererID = localStorage.getItem('wandererGenesisID');
    if (!wandererID) {
      const randomNum = Math.floor(1000000 + Math.random() * 9000000);
      wandererID = `W${randomNum}`;
      localStorage.setItem('wandererGenesisID', wandererID);
    }
    return wandererID;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!consentChecked) {
      alert('Please confirm consent checkbox');
      return;
    }

    setSubmitting(true);

    try {
      const genesisID = getOrCreateGenesisID();

      const response = await fetch('https://1kn7g0vf8j.execute-api.us-east-1.amazonaws.com/submitDesignerApplication', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          genesisID,
          formData,
          email: formData.email
        })
      });

      const result = await response.json();

      if (result.success) {
        alert(`Application submitted successfully!\n\nYour Genesis ID: ${genesisID}\n\nCertificate will be sent to ${formData.email}`);
        onNavigate('home');
      } else {
        alert('Failed to submit application: ' + (result.error || 'Unknown error'));
      }

    } catch (error) {
      console.error('Submission error:', error);
      alert('Failed to submit application. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="casting-page">
      <div className="casting-container">
        <div className="casting-form">
          {/* Header */}
          <div className="casting-header">
            <h2>Designers & Stylists Application</h2>
            <p>Join Genesis by Theo's Creative Network</p>
          </div>

          <form onSubmit={handleSubmit}>
            {/* Section 1: Personal Information */}
            <div className="form-section">
              <h3>
                <span className="section-number">1</span>
                Personal Information
              </h3>
              
              <div className="form-group">
                <label>Full Name *</label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Phone Number *</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Profession *</label>
                <select
                  name="profession"
                  value={formData.profession}
                  onChange={handleChange}
                  required
                >
    <option value="">Select Your Role</option>
    <option value="Designer">Designer</option>
    <option value="Stylist">Stylist</option>
    <option value="Photographer">Photographer</option>
    <option value="Videographer">Videographer</option>
    <option value="Photo/Video Editor">Photo/Video Editor</option>
                </select>
              </div>

              <div className="form-group">
                <label>Years of Experience *</label>
                <input
                  type="number"
                  name="yearsExperience"
                  value={formData.yearsExperience}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Specialty</label>
                <input
                  type="text"
                  name="specialty"
                  placeholder="e.g. Evening wear, Street fashion"
                  value={formData.specialty}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Section 2: Portfolio & Links */}
            <div className="form-section">
              <h3>
                <span className="section-number">2</span>
                Portfolio & Links
              </h3>

              <div className="form-group">
                <label>Portfolio Link *</label>
                <input
                  type="url"
                  name="portfolioLink"
                  value={formData.portfolioLink}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Website (Optional)</label>
                <input
                  type="url"
                  name="websiteLink"
                  value={formData.websiteLink}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Instagram Handle</label>
                <input
                  type="text"
                  name="instagram"
                  placeholder="@username"
                  value={formData.instagram}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Section 3: Availability & Bio */}
            <div className="form-group">
  <label>Flexibility to Travel Between New York and Europe *</label>
  <select 
    name="travelFlexibility" 
    value={formData.travelFlexibility} 
    onChange={handleChange}
    required
  >
    <option value="">Select your travel flexibility</option>
    <option value="fullFlexibility">Full Flexibility - Can travel regularly</option>
    <option value="moderateFlexibility">Moderate - Can travel occasionally</option>
    <option value="limitedFlexibility">Limited - Prefer remote work</option>
    <option value="noFlexibility">Not available for international travel</option>
  </select>
</div>
            <div className="form-section">
              <h3>
                <span className="section-number">3</span>
                Availability & Bio
              </h3>

              <div className="form-group">
                <label>Availability</label>
                <input
                  type="text"
                  name="availability"
                  placeholder="e.g. Full-time, Freelance, Part-time"
                  value={formData.availability}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Short Bio / Introduction (max 200 words)</label>
                <textarea
                  name="bio"
                  value={formData.bio}
                  onChange={handleChange}
                  maxLength={1200}
                  rows="5"
                  placeholder="Tell us about your design philosophy and experience..."
                />
              </div>
            </div>

            {/* Section 4: Consent */}
            <div className="form-section">
              <h3>
                <span className="section-number">4</span>
                Consent
              </h3>

<div className="form-group">
  <label 
    style={{ 
      display: 'flex', 
      alignItems: 'flex-start', 
      gap: '10px', 
      cursor: 'pointer',
      flexWrap: 'wrap'  // ✅ ДОДАНО
    }}
  >
    <input
      type="checkbox"
      checked={consentChecked}
      onChange={(e) => setConsentChecked(e.target.checked)}
      required
      style={{ marginTop: '4px', flexShrink: 0 }}  // ✅ ДОДАНО flexShrink: 0
    />
    <span style={{ flex: 1, minWidth: '200px', wordWrap: 'break-word' }}>  {/* ✅ ДОДАНО */}
      I confirm that all information is correct and consent to be contacted for design opportunities via GENESIS.
    </span>
  </label>
</div>
            </div>

            {/* Navigation Buttons */}
            <div className="navigation-buttons">
              <button 
                type="button" 
                onClick={() => onNavigate('home')} 
                className="btn-cancel"
              >
                Cancel
              </button>
              
              <button 
                type="submit" 
                disabled={submitting} 
                className="btn-submit"
              >
                {submitting ? 'Submitting...' : 'Submit Application'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default DesignerApplicationPage;
